export type ClinicJourneyStatus =
  "researching" | "contacted" | "consulted" | "in-treatment" | "past-patient";

// Temporary compatibility contract until provider interactions expose a
// structured journey-status field. Only this exact prefix is interpreted;
// every other note remains patient-authored text.
const STATUS_PREFIX_RE =
  /^\[status:(researching|contacted|consulted|in-treatment|past-patient)\](?:\r?\n|$)/;

export function parseClinicNotesField(raw: string): {
  status: ClinicJourneyStatus | null;
  text: string;
} {
  const match = raw.match(STATUS_PREFIX_RE);
  if (match) {
    return {
      status: match[1] as ClinicJourneyStatus,
      text: raw.slice(match[0].length),
    };
  }
  return { status: null, text: raw };
}

export function encodeClinicNotesField(
  status: ClinicJourneyStatus | null,
  text: string,
): string {
  if (!status && !text.trim()) return "";
  if (!status) return text;
  if (!text.trim()) return `[status:${status}]`;
  return `[status:${status}]\n${text}`;
}
